// mutations
const SCHOOLROUTES_ROUTES_ALL = (state, schoolroutesRoutes) => {
  if (schoolroutesRoutes.code === 1) {
    state.schoolroutesRoutes = schoolroutesRoutes.data
    state.status = 'success'
  } else {
    alert(schoolroutesRoutes.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_ROUTES_FORM = (state, schoolroutesRoutes) => {
  if (schoolroutesRoutes.code === 1) {
    state.schoolroutesRoutes = schoolroutesRoutes.data
    state.status = 'success'
  } else {
    alert(schoolroutesRoutes.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_ROUTES_SHOW = (state, schoolroutesRoutes) => {
  if (schoolroutesRoutes.code === 1) {
    state.schoolroutesRoutes = schoolroutesRoutes.data
    state.status = 'success'
  } else {
    alert(schoolroutesRoutes.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_ROUTES_CREATE = (state, schoolroutesRoutes) => {
  if (schoolroutesRoutes.code === 1) {
    state.schoolroutesRoutes = schoolroutesRoutes.data
    state.status = 'success'
  } else {
    alert(schoolroutesRoutes.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_ROUTES_UPDATE = (state, schoolroutesRoutes) => {
  if (schoolroutesRoutes.code === 1) {
    state.schoolroutesRoutes = schoolroutesRoutes.data
    state.status = 'success'
  } else {
    alert(schoolroutesRoutes.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_ROUTES_DELETE = (state, schoolroutesRoutes) => {
  if (schoolroutesRoutes.code === 1) {
    state.schoolroutesRoutes = schoolroutesRoutes.data
    state.status = 'success'
  } else {
    alert(schoolroutesRoutes.message)
    state.status = 'error'
  }
}

export default {
  SCHOOLROUTES_ROUTES_ALL,
  SCHOOLROUTES_ROUTES_FORM,
  SCHOOLROUTES_ROUTES_SHOW,
  SCHOOLROUTES_ROUTES_CREATE,
  SCHOOLROUTES_ROUTES_UPDATE,
  SCHOOLROUTES_ROUTES_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/routes/mutations.js